import breakpoints 			from './constants/breakpoints.json'

export default breakpoints